import "./HelpRegistry.css"

const HelpItem = (title, description) => (
  <div class="help-item">
    <strong>{title}</strong>
    <span>{description}</span>
  </div>
);


const CommonHelpItems = (
<>
  {HelpItem("Lock", "Prevents the rectangle from being moved or edited.")}
  {HelpItem("Move", "Moves the rectangle to a different location on the canvas.")}
  {HelpItem("Delete", "Deletes the rectangle from the page.")}
  {HelpItem("Copy", "Creates a copy of the rectangle.")}
  {HelpItem("Push To Back", "Moves the rectangle behind other rectangles.")}
  {HelpItem("Push To Front", "Moves the rectangle in front of other rectangles.")}
  {HelpItem("Copy To Clipboard", "Copies the rectangle to the clipboard for use on another page or file.")}

</>    
  
);



const ExpCommonHelpItems = (
  <>
    {HelpItem("Expand Upwards", "Extends the rectangle upward.")}
    {HelpItem("Expand Leftwards", "Extends the rectangle to the left.")}
    {HelpItem("Expand Rightwards", "Extends the rectangle to the right.")}
    {HelpItem("Expand Downwards", "Extends the rectangle downward.")}
  </>
);

const ImageHelpItems = (
<>
  {HelpItem("Image Selector", "Choose an image from the images already saved in your project folder to use in your design.")}
  {HelpItem("Modify Image with AI", "Describe how you want to change the image, and AI will generate a modified version in its place. Your original image remains safely stored in your project folder.")}
  {HelpItem("Link", "Make an image clickable to navigate to an external URL or another HTML page within the same AIT file.")}
</>
);

const AnimateHelpItems = (
  <>
    {HelpItem("Rotate", "This will rotate the Animate Rectangle counter clockwise")}    
    {HelpItem("Settings", "Brings up a dialog box to set up the animation object and path")}
    
  </>
  );

const SvgTextHelpItems = (
    <>
      {HelpItem("Rotate", "This will rotate the Text counter clockwise")}    
      {HelpItem("Text Options", "This brings up a dialog box that let's you set the text, font, stroke, color, opacity and unicode characters")}
      {HelpItem("Effects", "This brings up a dialog box that let's you create a shadow and blur around the text")}
      {HelpItem("Link", "Make the text clickable to navigate to an external URL or another HTML page within the same AIT file.")}
      
    </>
    );
  
const BezierHelpItems = (
  <>
    {HelpItem("Emojis", "Allows you to choose an openmoji icon and place it in the rectangle")}
    {HelpItem("Import SVG", "You can import a SVG from file")}
    {HelpItem("Export SVG", "You can export SVG to an external file. The default name of external file is bezier.svg")}
    {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
    {HelpItem("Explode", "This allows the bezier drawing from the rectangle to be manually edited")}
  </>

);

const PrectHelpItems = (
  <>
    {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
    {HelpItem("Explode", "This allows the bezier drawing from the rectangle to be manually edited")}
  </>

);


const FlipHelpItems = (
  <>
    {HelpItem("Rotate", "This will rotate the drawing counter clockwise")}
    {HelpItem("Flip Vertical", "This will flip the drawing from the center vertical line of the rectangle")}
    {HelpItem("Flip Horizontal", "This will flip the drawing from the center horizontal line of the rectangle")}  
  </>
);
const ExtraHelpItems = (
  <>
      {HelpItem("Clip", "Lets you select an image that will be clipped by this shape")}
      {HelpItem("Image Adjust", "This changes the screen mode so that the mouse wheel scroll will zoom the clipped image, and left mouse drag will pan the image")}
      {HelpItem("Settings", "This brings up a dialog box that let's you set, stroke, color, fill, and opacity of the shape")}
      {HelpItem("Effects", "This brings up a dialog box that let's you create a shadow and blur around the shape")}
  </>
);
const AiArtHelpItems = (
  <>
    {HelpItem("Generate Bezier From AI", "Uses Gpt Astra to convert this Rectangle to a Bezier Rectangle based off of your prompt")}
    {HelpItem("Generate Image From AI", "Uses Gpt Sunburst to convert this Rectangle to an Image Rectangle displaying the generated image")}    
  </>
);

const AiHtmlHelpItems = (
  <>  
    {HelpItem("Generate Code From AI", "Uses Gpt Astra to generate css, html, and/or js code within this rectangle")}
    {HelpItem("Edit AI Code", "You can edit the manually generated AI Code from here")}    
    {HelpItem("Export AI Code", "You can save the generated AI Code to a file")}    
  </>
);


export const HELP_CONTENT = {
    new_hover: (
      <>
        <h3>New file</h3>
        <p>This button creates a new Ait template file. It will prompt you for a file name to enter. Do not add an extension to the name. This file will be saved in html and ait format</p>
        <p>In the demo version, this button only allows one ait file</p>
        
      </>
    ),
  
    open_hover: (
      <>
        <h3>Open file</h3>
        <p>This button brings up a list of ait files that exist in your directory, allowing you to select one to open.</p>
        <p>The file name is shown on top right of the ribbon menu</p>

      </>
    ),

    export_hover: (
      <>
        <h3>Export Current Layout</h3>
          <p>This button exports the current layout as an .ait file onto your local computer</p>          

      </>
    ),
    addDevice_hover: (
      <>
          <h3>Add a Device Page</h3>
          <p>
            Adds a new page at the device width selected in the dropdown.
            The page is added to the current AIT file, not a separate file.
            The contents of the extra small page are copied to the new device page.
          </p>

          <p>
            <strong>Page order:</strong> The new page is placed after the
            appropriate ExtraSmall page and before the next ExtraSmall page,
            according to the selected device width. 
          </p>

          <p>
            <strong>Scroll navigation:</strong> The page appears after the
            previous rendered page.
          </p>

          <p>
            <strong>Link navigation:</strong> The page appears only when
            reached through an internal link.
          </p>

          <p>
            <strong>Deleting pages:</strong> The device pages can be deleted in any order.
          </p>
      </>
    ),
    addPage_hover: (
      <>

          <h3>Add a New Page</h3>

          <p>
            Adds a page to the current AIT file, starting at ExtraSmall width.
            The page count increases, for example, from 1 of 1 to 2 of 2.
          </p>

          <p>
            <strong>Page order:</strong> New pages follow the existing page
            sequence. Adding a wider device width can also create a page in
            that sequence, depending on the existing pages.
          </p>

          <p>
            <strong>Scroll navigation:</strong> Each page appears after the
            previous rendered page, regardless of the device widths between them.
          </p>

          <p>
            <strong>Link navigation:</strong> A page appears only when reached
            through an internal link.
          </p>

          <p>
            <strong>Deleting pages:</strong> Extra Small pages must be deleted in order. The first page cannot be deleted.
          </p>
      </>
    ),

    deletePage_hover: (
      <>
          <h3>Delete Current Page</h3>
          <p>If this button is disabled, it means that this page depends on you deleting the later pages before you are allowed to delete this one</p>
      </>

    ),
    prevPage_hover: (
      <>
          <h3>Previous Page</h3>
          <p>This button takes you to the previous page in this .ait file</p>
      
      </>

    ),
    nextPage_hover: (
      <>
          <h3>Next Page</h3>
          <p>This button takes you to the next page in this .ait file</p>      
      </>

    ),

    import_hover: (
      <>
        <h3>Import Current Layout</h3>
        <p>This button allows a user to load a locally stored .ait file into the editor</p>          
      </>
    ),
    image: (
      <h3>Move Image Rectangle onto the canvas, then click to place.</h3>
    ),
    image_hover: (
      <>
        <h3>Image Rectangle</h3>
          <p>This rectangle displays an image that you can select.</p>                    
      </>
    ),
    
    aiart: (
      <h3>Move AI Art Rectangle onto the canvas, then click to place.</h3>
    ),
    aiart_hover: (
      <>
        <h3>AI Art Rectangle</h3>
          <p>This is a temporary rectangle that uses AI.</p>         
          <p>It exposes two AI functions. Generate Vector and Generate Image.</p>
          <p>The generate Vector will create a svg and display it. The rectangle will turn into a Bezier Rectangle.</p>
          <p>The generate Image will display a raster image on the screen. The rectangle will change into an Image Rectangle</p>          
      </>
    ),

    airect: (
      <h3>Move AI Html onto the canvas, then click to place.</h3>
    ),


    airect_hover:(
      <>
        <h3>AI Html</h3>
          <p>This rectangle allows the user to Generate AI Code</p>                   
          <p>The AI generated HTML will run within the rectangle.</p>          
      </>
    ),       
  
    svgrect: (
      <h3>Move Svg Rectangle onto the canvas, then click to place.</h3>
    ),


    svgrect_hover:(
      <>
        <h3>Svg Rectangle</h3>
          <p>This rectangle allows the user to place a rectangle on the screen</p>                   
      </>
    ),       

    svgsquare: (
      <h3>Move Svg Square onto the canvas, then click to place.</h3>
    ),


    svgsquare_hover:(
      <>
        <h3>Svg Square</h3>
          <p>This rectangle allows the user to place a square on the screen</p>                   
      </>
    ),       


    svgcircle: (
      <h3>Move Svg Circle onto the canvas, then click to place.</h3>
    ),


    svgcircle_hover:(
      <>
        <h3>Svg Circle</h3>
          <p>This rectangle allows the user to place a circle on the screen</p>                   
      </>
    ),       

    svgellipse: (
      <h3>Move Svg Ellipse onto the canvas, then click to place.</h3>
    ),


    svgellipse_hover:(
      <>
        <h3>Svg Ellipse</h3>
          <p>This rectangle allows the user to place an ellipse on the screen</p>                   
      </>
    ),       

  

    rect_hover: (
      <>
      <h3>Human Html</h3>
      <p>      
        This rectangle allows you to call up a Rich Text Editor.
      </p>
      
    </>),
    animate: (
          <h3>Move Animate Rectangle onto the canvas, then click to place.</h3>
        ),
        
    animate_hover: (
      <>
        <h3>Animate Rectangle</h3>
        <p>      
          This rectangle allows simple animations.
        </p>
        <p>      
          The user can select an object and path and have the object move along the path.
        </p>
        <p>
          There are simple animations to scale, rotate or fade an object, with or without a path.
        </p>                    
        <p>
          A Bezier Rectangle is used to define a path. A Bezier Rectangle, SVG Text, SVG Circle, SVG Rect or SVG Square could be used to define the animated object.
        </p>                    
        <p>
          The animation is constrained to the rectangle.
        </p>

      </>),
      
    svgtext: (
      <h3>Move Text Rectangle onto the canvas, then click to place.</h3>
    ),


    svgtext_hover: (
      <>
      <h3>Text Rectangle</h3>
      <p>      
        This rectangle allows you to display a specific font and have it rendered as an SVG in a browser. Unicode characters and glyphs can also be displayed. These glyphs can be converted to SVG and modified within this editor.
      </p>
      <p>
        In order to get editable SVG, this rectangle must be converted into a Bezier Rectangle first.
      </p>
      <p>      
        The following fonts can be selected:
        <ul>
          <li>
              Roboto
          </li>
          <li>
              ComicNeue
          </li>
          <li>
              ComicRelief
          </li>
          <li>
              Playfair
          </li>
          <li>
              BabasNeue
          </li>
          <li>
              Montserrat
          </li>
          <li>
              Lora
          </li>
          <li>
            Oswald
          </li>
          <li>
              Pacifico
          </li>
          <li>
              Satoshi
          </li>
          <li>
            NotoSansSymbols2
          </li>
        </ul>
      </p>              
    </>),

    svgemoji: (
      <h3>Move Bezier Rectangle onto the canvas, then click to place.</h3>
    ),

    svgemoji_hover:(
      <>
      <h3>Bezier Rectangle</h3>
      <p>      
        A Bezier Rectangle is an SVG that can be rendered. This rectangle uses svg's from the openmoji library. 
      </p>
      <p>      
        A Bezier Rectangle can be exploded and edited in "Bezier"  mode
      </p>      
    </>),

    PageDimensions_hover: (
      <>
        <h3>Page Dimensions</h3>
        <p>      
          To set the page dimensions, right-click anywhere on the canvas to open the Page Menu. Make sure no objects are selected.
        </p>
        <p>      
          In addition to setting up the page dimensions, the title and color of the page can also be set by this menu.
        </p>      

      </>
    ),
    Navigation_hover: (
      <>
        <h3>Browser Navigation Type</h3>
          <p>
            Choose how visitors navigate between pages when your AIT file is rendered in the browser. The navigation type determines whether all pages for a device are accessible by scrolling or whether pages are displayed individually through internal links.
          </p>
          <p>
            <strong>Scroll:</strong> All pages for the selected device type are displayed in sequence and can be accessed by scrolling. For example, on a small device, visitors can scroll through all pages designed for small screens.
          </p>
          <p>
            <strong>Linked:</strong> Only the first page for the selected device type is displayed initially. Other pages become visible when an internal link navigates to them. Each page has a unique identifier that allows it to be targeted by internal links.
          </p>
      </>
    ),

    pline_hover: (
      <>
        <h3>plinehover</h3>
      </>
    ),

    rect: (
        <h3>Move Human HTML onto the canvas, then click to place.</h3>
    ),

    pline: (
      <>
        <h3>pline mode</h3>
      </>
    ),

    none: (
        <>
          <p> No Selection</p>
        </>
    ),
    multi: (
      <>
              <div class="help-section">

            <h2>Multiple Rectangles</h2>

            <p>
              This group of rectangles has the following context menu actions:
            </p>

            <div class="help-item">
              <strong>lockAll</strong>
              <span>Prevents all rectangles within selection from being moved or edited.</span>
            </div>
            <div class="help-item">
              <strong>unlockAll</strong>
              <span>allow rectangles within selection to be moved or edited.</span>
            </div>

            <div class="help-item">
              <strong>Move</strong>
              <span>Moves the rectangle to a different location on the canvas.</span>
            </div>

            <div class="help-item">
              <strong>Delete</strong>
              <span>Deletes the rectangle from the page.</span>
            </div>

            <div class="help-item">
              <strong>Copy</strong>
              <span>Creates a copy of the rectangle.</span>
            </div>

            <div class="help-item">
              <strong>Push To Back</strong>
              <span>Moves the rectangle behind other rectangles.</span>
            </div>

            <div class="help-item">
              <strong>Push To Front</strong>
              <span>Moves the rectangle in front of other rectangles.</span>
            </div>

            <div class="help-item">
              <strong>Align Top</strong>              
              <span>Align top edges of the rectangles</span>
            </div>

            <div class="help-item">
              <strong>Align Left</strong>
              <span>Align left edges of the rectangles.</span>
            </div>

            <div class="help-item">
              <strong>Align Right</strong>
              <span>Align right edges of the rectangles.</span>              
            </div>

            <div class="help-item">
              <strong>Align Bottom</strong>
              <span>Align bottom edges of the rectangles.</span>
            </div>

            <div class="help-item">
              <strong>Group Together</strong>
              <span>This will group the rectangles into a single Group rectangle</span>
            </div>

            </div>

      </>
    ),
    RectangleText: (
      <>
      <div class="help-section">

          <h2>Human HTML</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {ExpCommonHelpItems}

          {HelpItem("HTML Editor", "Opens the editor for modifying the rectangle's HTML.")}

          </div>
      </>          
    ),
    RectangleImage: (
      <>
      <div class="help-section">

          <h2>Image</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {ExpCommonHelpItems}
          {ImageHelpItems}
        </div>
      </>          
    ),
    RectangleAnimate: (
      <>
      <div class="help-section">

          <h2>Animate</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}          
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {AnimateHelpItems}
        </div>
      </>          
    ),
    SvgText: (
      <>
      <div class="help-section">

          <h2>Svg Text</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}          
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {SvgTextHelpItems}
        </div>
      </>          
    ),

    RectangleCustom: (
      <>
        <div class = "help-section">
          <h2>AI HTML</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {ExpCommonHelpItems}
          {AiHtmlHelpItems}
        </div>

      </>
    ),
    Bezier_multi: (
      <>
        <div class = "help-section">
          <h2>Bezier (multi line) </h2>

          <p>This is a multi line Bezier and it's context menu does not allow clipping and other functions without exploding</p>

          {CommonHelpItems}        
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {FlipHelpItems}
          {BezierHelpItems}
        </div>
      </>
    ),
    Bezier: (
      <>
        <div class = "help-section">
          <h2>Bezier (single line) </h2>

          <p>This is a single line Bezier and it's context menu allows extra functions </p>
          
          {CommonHelpItems}       
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {FlipHelpItems}
          {ExtraHelpItems} 
          {BezierHelpItems}
        </div>
      </>
    ),

    Prect_multi: (
      <>
        <div class = "help-section">
          <h2>Polyline Rectangle without curves (multi line) </h2>

          <p>This is a multi line Bezier and it's context menu does not allow clipping and other functions without exploding</p>

          {CommonHelpItems}        
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {FlipHelpItems}
          {PrectHelpItems}
        </div>
      </>
    ),
    Prect: (
      <>
        <div class = "help-section">
          <h2>Polyline Rectangle without curves (single line) </h2>

          <p>This is a single line shape and it's context menu allows extra functions </p>
          
          {CommonHelpItems}  
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {FlipHelpItems}
          {ExtraHelpItems}
          {PrectHelpItems}           
        </div>
      </>
    ),

    RectangleSvgCircle: (
      <>
        <div class = "help-section">
          <h2>Svg Rectangle </h2>

          This rectangle has the following context menu actions:
                    
          {CommonHelpItems}  
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {HelpItem("Rotate", "This will rotate the Text counter clockwise")}    
          {ExpCommonHelpItems}
          {ExtraHelpItems}
          {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
        </div>

      </>

    ),
    RectangleSvgSquare: (
      <>
        <div class = "help-section">
          <h2>Svg Square </h2>

          This rectangle has the following context menu actions:
                    
          {CommonHelpItems}  
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {HelpItem("Rotate", "This will rotate the Text counter clockwise")}    
          {ExpCommonHelpItems}
          {ExtraHelpItems}
          {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
        </div>

      </>

    ),
    RectangleSvgRect: (
      <>
        <div class = "help-section">
          <h2>Svg Rectangle </h2>

          This rectangle has the following context menu actions:
                    
          {CommonHelpItems}  
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {HelpItem("Rotate", "This will rotate the Text counter clockwise")}    
          {ExpCommonHelpItems}
          {ExtraHelpItems}
          {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
        </div>

      </>

    ),
    clip: (
      <>
        <div class = "help-section">
          <h2>Clipboard</h2>
          This rectangle has the following context menu actions:
          {HelpItem("Select", "This allows you to select an element from the clipboard that you wish to paste onto the page")}     
          {HelpItem("Clear Clipboard", "This clears the clipboard")}     
        </div>
      </>
    ),
    RectangleSvgEllipse: (
      <>
        <div class = "help-section">
          <h2>Svg Ellipse </h2>

          This rectangle has the following context menu actions:
                    
          {CommonHelpItems}  
          {HelpItem("Copy To Bezier", "Creates a new Bezier rectangle with control points for adjusting shape")}     
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {HelpItem("Rotate", "This will rotate the Text counter clockwise")}    
          {ExpCommonHelpItems}
          {ExtraHelpItems}
          {HelpItem("Link", "Make the rectangle clickable to navigate to an external URL or another HTML page within the same AIT file.")}
        </div>

      </>

    ),


    RectangleAiArt: (
      <>
        <div class = "help-section">
          <h2>AI Art</h2>

          <p>
            This rectangle has the following context menu actions:
          </p>

          {CommonHelpItems}        
          {HelpItem("Resize", "Changes the width and height of the rectangle.")}
          {ExpCommonHelpItems}
          {AiArtHelpItems}
        </div>
      </>
    )

  };


  export const DEFAULT_HELP = (

    <div className="gesture-cheat-sheet">

          <h3>Getting Started</h3>

          <p>
            Hover over any tool to see more detailed instructions.
          </p>

          <p>
            <strong>Everything on the page is built from rectangles.</strong> Think of
            each rectangle as a container that can hold text, images, drawings, HTML,
            or other content. Build your page by placing and arranging rectangles
            on the canvas.
          </p>

          <h3>Poster-Style Layout</h3>
          <p>
            This editor uses a poster-style layout. Each rectangle is placed at a specific
            position on the page, giving you precise control over where your content
            appears.
          </p>

          <p>
            Unlike traditional web builders, rectangles do not automatically resize or
            reposition themselves when other content changes. What you place on the
            page stays where you put it.
          </p>

          <p>
            Think of the page like a digital poster or canvas: you decide where each
            piece goes, how large it is, and how it overlaps with other pieces.
          </p>


          <h3>Rectangle Groups</h3>

          <p>
            Multiple selected rectangles can be grouped into a single rectangle.
          </p>


          <h3>The Clipboard</h3>

          <p>
            The clipboard temporarily stores rectangles so you can copy them between
            pages within the same <code>.ait</code> file, or between different
            <code>.ait</code> files.
          </p>

          <p>
            To copy multiple rectangles, first group them and then copy the group
            to the clipboard.
          </p>

          <p>
            The Clipboard acts like a special rectangle with its own context menu for
            selecting and clearing copied rectangles.
          </p>        

          <h3>Preview Your Page</h3>
          <p>
            The canvas is an editing view and may not look exactly like the final
            browser page.
          </p>

          <p>
            <strong>Preview your page to see how it will be rendered in the browser.</strong>
            Use the preview to check your layout, then return to the editor and make
            adjustments as needed.
          </p>



          <h3>Page Sizes</h3>

          <p>
            Each page size is a separate version of your page for different device
            sizes. The browser automatically displays the appropriate version based
            on the available screen size.
          </p>

          <p>
            Smaller page sizes are always shown at their corresponding screen size.
            Larger versions replace the smaller version when the screen is wide
            enough to use them.
          </p>
          <p>
            <strong>For example:</strong> You might create a small page for phones and
            a larger version for tablets or desktops. When the browser becomes wide
            enough, the larger version is displayed instead of the small version.
          </p>

          <p>
            This means you may need to edit more than one page size. Resize your
            browser while previewing to check how your page looks on different
            devices.
          </p>


          <h3>Context Menu</h3>
              <p>
                <strong>Right-click a rectangle to access its properties and available
                actions.</strong> The context menu is the main place to edit, modify,
                arrange, and manage rectangles.
              </p>

              <p>
                The available options depend on what is selected. Right-clicking multiple
                selected rectangles provides additional group and multi-selection actions.
              </p>




      </div>    
  );

  